export {
  auth,
  onAuthStateChanged,
  signOut,
  notifyStaffAuthChanged,
} from './appAuth';
export { auth as default } from './appAuth';

export const browserLocalPersistence = { type: 'LOCAL' };
export const browserSessionPersistence = { type: 'SESSION' };

export async function setPersistence() {
  return undefined;
}

export async function reload() {
  return undefined;
}

export async function getIdToken(user, _force) {
  if (user?.getIdToken) return user.getIdToken();
  return null;
}

export function getAuth() {
  return require('./appAuth').auth;
}

export async function signInWithEmailAndPassword(_auth, email, password) {
  const { loginWithPassword } = await import('../api/localAuth');
  await loginWithPassword(email, password);
  const { auth } = await import('./appAuth');
  return { user: auth.currentUser };
}

export async function createUserWithEmailAndPassword(_auth, email, password) {
  const { registerSession } = await import('../api/localAuth');
  await registerSession({ email, password, kind: 'staff' });
  const { auth } = await import('./appAuth');
  return { user: auth.currentUser };
}

export async function signInWithCustomToken(_auth, token) {
  const { setLocalSessionToken } = await import('../api/authToken');
  const { notifyStaffAuthChanged } = await import('./appAuth');
  setLocalSessionToken(token);
  notifyStaffAuthChanged();
  const { auth } = await import('./appAuth');
  return { user: auth.currentUser };
}

export async function signInAnonymously() {
  return { user: null };
}

export async function signInWithPopup() {
  throw new Error('Google sign-in is not available');
}

export class GoogleAuthProvider {}
export class EmailAuthProvider {
  static credential(email, password) {
    return { email, password };
  }
}

export async function reauthenticateWithCredential(_user, credential) {
  const { loginWithPassword } = await import('../api/localAuth');
  await loginWithPassword(credential.email, credential.password);
  return { user: require('./appAuth').auth.currentUser };
}

export async function updatePassword() {
  throw new Error('Use changePassword with the current password');
}

export async function updateEmail() {
  return undefined;
}

export async function updateProfile() {
  return undefined;
}

export async function verifyBeforeUpdateEmail() {
  return undefined;
}

export async function sendEmailVerification() {
  return undefined;
}

export async function applyActionCode() {
  return undefined;
}

export async function checkActionCode() {
  return { operation: 'UNKNOWN' };
}

export async function verifyPasswordResetCode() {
  return '';
}

export async function confirmPasswordReset(_auth, token, password) {
  const { consumePasswordReset } = await import('../api/localAuth');
  await consumePasswordReset({ token, password });
}
